import uiRouter from '@uirouter/angularjs';
import get from 'lodash/get';
import { LaunchDarklyServiceModule } from 'services/access/launchDarkly/launchDarkly.service';

// Finished pages in new admin
export const redirects = [
    { from: 'dashboard', to: '/', launchDarklyKey: 'dashboard' },

    { from: 'order.list', to: '/orders/all', launchDarklyKey: 'orders' },
    { from: 'order.add', to: '/orders/create', launchDarklyKey: 'orders' },
    { from: 'order.edit', to: ({ id }) => `/orders/${id}/edit`, launchDarklyKey: 'orders' },
    { from: 'order.detail', to: ({ id }) => `/orders/${id}`, launchDarklyKey: 'orders' },
    { from: 'packingSlip', to: ({ id }) => `/orders/${id}/shipping-label`, launchDarklyKey: 'orders' },
    { from: 'shippingLabel', to: ({ id }) => `/orders/${id}/packing-slip`, launchDarklyKey: 'orders' },
    { from: 'invoiceToShopper', to: ({ id }) => `/orders/${id}/invoice-to-shopper`, launchDarklyKey: 'orders' },

    { from: 'product.list', to: '/products/all', launchDarklyKey: 'products.list' },
    { from: 'product.list', to: '/products/all', launchDarklyKey: 'products' },
    { from: 'product.add', to: '/products/create', launchDarklyKey: 'products' },
    { from: 'product.detail', to: ({ id }) => `/products/${id}`, launchDarklyKey: 'products' },

    { from: 'category.list', to: '/categories/all', launchDarklyKey: 'categories' },
    { from: 'category.add', to: '/categories/create', launchDarklyKey: 'categories' },
    { from: 'category.detail', to: ({ id }) => `/categories/${id}`, launchDarklyKey: 'categories' },

    { from: 'customer.list', to: '/customers/all', launchDarklyKey: 'customers' },
    { from: 'customer.add', to: '/customers/create', launchDarklyKey: 'customers' },
    { from: 'customer.detail', to: ({ id }) => `/customers/${id}`, launchDarklyKey: 'customers' },

    { from: 'appstore2.installedapps2', to: '/apps/installed', launchDarklyKey: 'apps' },
    { from: 'appstore2.allapps2', to: '/apps/all', launchDarklyKey: 'apps' },

    { from: 'settings.detail', to: '/settings/store', launchDarklyKey: 'settings' },
    { from: 'settings.payments', to: '/settings/payments', launchDarklyKey: 'settings' },
    { from: 'settings.shipping', to: '/settings/shipping', launchDarklyKey: 'settings' },
    { from: 'settings.seo', to: '/settings/seo', launchDarklyKey: 'settings' },
    { from: 'settings.authorizeNet', to: '/settings/volusionpayments/application', launchDarklyKey: 'settings' },

    { from: 'analytics.main', to: '/analytics', launchDarklyKey: 'analytics' },
    { from: 'analytics.abandonedCartsList', to: '/analytics/carts', launchDarklyKey: 'analytics' },
    { from: 'analytics.abandonedCartDetail', to: ({ id }) => `/analytics/carts/${id}`, launchDarklyKey: 'analytics' },

    { from: 'designer', to: '/designer', launchDarklyKey: 'siteDesigner' },

    { from: 'pages.list', to: '/pages/all', launchDarklyKey: 'pages' },
    { from: 'pages.add', to: '/pages/create', launchDarklyKey: 'pages' },
    { from: 'pages.detail', to: ({ id }) => `/pages/${id}`, launchDarklyKey: 'pages' },

    // Menu redirect is handled in pages/editstore/editstore.module.js
    // { from: 'editstore.menu', to: '/menu', launchDarklyKey: 'menuEditor' },

    { from: 'myAccount', to: '/my-account', launchDarklyKey: 'myAccount' },
    { from: 'cancelStore', to: '/my-account/cancel-store', launchDarklyKey: 'myAccount' },

    { from: 'discounts.list', to: '/discounts/all', launchDarklyKey: 'discounts' },
    { from: 'discounts.add', to: '/discounts/create', launchDarklyKey: 'discounts' },
    { from: 'discounts.detail', to: ({ id }) => `/discounts/${id}`, launchDarklyKey: 'discounts' },

    { from: 'fulfillers.*', to: '/apps/fulfillers', launchDarklyKey: 'fulfillers' },
    { from: 'googleAnalytics', to: '/apps/googleanalytics', launchDarklyKey: 'googleAnalytics' },
    { from: 'postage.*', to: '/apps/shipping', launchDarklyKey: 'shippo' },
    { from: 'pinterest', to: '/apps/pinterest', launchDarklyKey: 'pinterest' },
    { from: 'yotpo', to: '/apps/yotpo', launchDarklyKey: 'yotpo' },
    { from: 'mailchimp', to: '/apps/mailchimp', launchDarklyKey: 'mailchimp' },
    { from: 'facebookPixel', to: '/apps/facebookpixel', launchDarklyKey: 'facebookpixel' },
    { from: 'fullstory', to: '/apps/fullstory', launchDarklyKey: 'fullstory' },
    { from: 'privy', to: '/apps/privy', launchDarklyKey: 'privy' },
    { from: 'zapier', to: '/apps/zapier', launchDarklyKey: 'zapier' },
    { from: 'chat', to: '/apps/chat', launchDarklyKey: 'chat' },
    { from: 'amazon', to: '/apps/amazon', launchDarklyKey: 'amazon' },
    { from: 'quickbooks', to: '/apps/quickbooks', launchDarklyKey: 'quickbooks' },
    { from: 'xero', to: '/apps/xero', launchDarklyKey: 'xero' },
    { from: 'globalshopex', to: '/apps/globalshopex', launchDarklyKey: 'globalshopex' },
    { from: 'avalara', to: '/avalara' },

    { from: 'storeCredit', to: '/storeCredit/all', launchDarklyKey: 'storeCredit' },
    { from: 'storeCredit.add', to: '/storeCredit/create', launchDarklyKey: 'storeCredit' },
    {
        from: 'storeCredit.detail',
        to: ({ storeCreditId }) => `/storeCredit/${storeCreditId}`,
        launchDarklyKey: 'storeCredit'
    }
];

export const launchDarklyKey = 'new-admin-features-enabled';

export const RedirectsModule = angular
    .module('app.services.redirects', [
        LaunchDarklyServiceModule,
        uiRouter
    ])
    .service('redirectsService', ($transitions, launchDarklyService, $q) => {
        const service = {
            registerRedirects,
            getRedirectPath,
            getEnabledRedirects,
            registerRedirectTransitionHooks
        };
        function registerRedirects() {
            return getEnabledRedirects(redirects)
                .then(enabledRedirects => registerRedirectTransitionHooks(enabledRedirects));
        }

        function getRedirectPath(to, urlParams) {
            let path;

            switch (typeof to) {
                case 'string':
                    path = to;
                    break;
                case 'function':
                    path = to(urlParams);
                    break;
                default:
                    path = '';
                    break;
            }

            return path;
        }

        function registerRedirectTransitionHooks(enabledRedirects) {
            // eslint-disable-next-line no-console
            console.log('Enabled redirects to new admin', enabledRedirects);

            const hooks = enabledRedirects.map((redirect) => {
                return $transitions.onStart({ to: redirect.from }, (transition) => {
                    const transitionParams = transition.targetState().params();
                    const params =
                        Object.keys(transitionParams)
                            .map(param => `${param}=${encodeURIComponent(transitionParams[param])}`);
                    const serializedParams = params.length ? `?${params.join('&')}` : '';

                    const redirectPath = getRedirectPath(redirect.to, transition._targetState._params);
                    window.location.href = `${process.env.NEW_ADMIN_BASE_URI}${redirectPath}${serializedParams}`;
                    // Prevent transition from finishing
                    return false;
                });
            });
            return () => hooks.forEach(unregisterHook => unregisterHook());
        }

        function getEnabledRedirects(allRedirects) {
            let initLD = launchDarklyService.initialized ? $q.resolve : launchDarklyService.initFromToken;
            return initLD().then(() => {
                return launchDarklyService.allFlags().then((flags) => {
                    const enabledFeatureKeys = get(flags, launchDarklyKey, []);
                    return allRedirects.filter(
                        redirect => enabledFeatureKeys.includes(redirect.launchDarklyKey)
                        || !redirect.launchDarklyKey
                    );
                });
            });
        }

        return service;
    }).name;



// WEBPACK FOOTER //
// ./src/app/redirects.js